import { render, staticRenderFns } from "./Developer.vue?vue&type=template&id=65b1b02e&scoped=true"
import script from "./Developer.vue?vue&type=script&lang=js"
export * from "./Developer.vue?vue&type=script&lang=js"
import style0 from "./Developer.vue?vue&type=style&index=0&id=65b1b02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b1b02e",
  null
  
)

export default component.exports